import { useHead } from '@vueuse/head';

const seoContent = {
  en: {
    title: 'AlUla Conference on Emerging Market Economies (ACEME) | Official Website',
    description: 'AlUla Conference on Emerging Market Economies (EME) is a high-level annual economic conference organized by the Saudi Ministry of Finance and the International Monetary Fund, bringing together finance ministers, central bank governors, policymakers, global investors, and institutional leaders to align economic policies amid global trade and monetary challenges.',
    keywords: 'AlUla Conference on Emerging Market Economies, AlUla ACEME, Annual Economic Conference, Finance Ministers, Central Bank Governors, Economic Policy Alignment, Emerging Markets, International Monetary Fund, Saudi Ministry of Finance'
  },
  ar: {
    title: 'مؤتمر العلا لاقتصادات الأسواق الناشئة | الموقع الرسمي',
    description: 'يُعد مؤتمر العلا لاقتصادات الأسواق الناشئة مؤتمرًا اقتصاديًا سنويًا رفيع المستوى، بتنظيم وزارة المالية وصندوق النقد الدولي، يجمع وزراء المالية ومحافظي البنوك المركزية وصنّاع السياسات وقادة المؤسسات الدولية لمناقشة مواءمة السياسات الاقتصادية في ظل تحديات التجارة العالمية والتحولات النقدية.',
    keywords: 'مؤتمر العلا لاقتصادات الأسواق الناشئة، AlUla ACEME، مؤتمر اقتصادي سنوي، وزراء المالية، محافظو البنوك المركزية، السياسات الاقتصادية، الأسواق الناشئة، صندوق النقد الدولي، وزارة المالية السعودية، مؤتمر العلا الاقتصادي'
  }
};

export function useSeo(customMeta = {}, lang = null) {
  const currentLang = lang || localStorage.getItem('language') || 'en';
  const defaultMeta = seoContent[currentLang] || seoContent.en;
  
  const meta = {
    title: customMeta.title || defaultMeta.title,
    description: customMeta.description || defaultMeta.description,
    keywords: customMeta.keywords || defaultMeta.keywords,
  };


  useHead({
    title: meta.title,
    meta: [
      {
        name: 'description',
        content: meta.description,
      },
      {
        name: 'keywords',
        content: meta.keywords,
      },
      {
        property: 'og:title',
        content: meta.title,
      },
      {
        property: 'og:description',
        content: meta.description,
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:title',
        content: meta.title,
      },
      {
        name: 'twitter:description',
        content: meta.description,
      },
    ],
    htmlAttrs: {
      lang: currentLang,
      dir: currentLang === 'ar' ? 'rtl' : 'ltr',
    },
  });

  return {
    title: meta.title,
    description: meta.description,
    keywords: meta.keywords,
    lang: currentLang,
  };
}
